module.exports = __webpack_public_path__ + "static/media/Loading_3.027dbfed.gif";